<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2 v-show="!trash">{{ $options.name }}s</h2>
        <h2 v-show="trash">{{ $options.name }}s - Trash</h2>
      </b-col>
    </div>

    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid terminal>
            <!-- Main table element -->
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" class="my-1">
								<b-dropdown class="pull-left" :text="dpdt">
									<b-dropdown-item @click="trashIC()">Active</b-dropdown-item>
									<b-dropdown-item @click="trashIC()">Trash</b-dropdown-item>
								</b-dropdown>
							</b-col>
              <b-col lg="5" class="my-1">
                <b-button variant="primary" class="pull-right" @click="newICModal">Add {{ $options.name }}

                </b-button>
              </b-col>
            </b-row>
            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table v-else striped hover bordered show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered"  @row-clicked="rowClicked">

            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->

              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New Modal -->
    <b-modal title="New Contract" size="lg" v-model="newIC" ok-only ok-title="Cancel" ok-variant="secundary">
      <b-row>
        <b-col cols="12">
            <b-form-group :label-cols="4" id="L1" label="Contract Name" label-for="Tdg1" horizontal>
              <b-form-input id="Tdg1" type="text" v-model="model.contract_name"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L2" horizontal label="Type Contract" label-for="Tdg2">
                <b-form-select :disabled="type_contract.length==0" value-field="id" text-field="name" id="Tdg2" v-model="model.type_contract_id" :options="type_contract" >
                    <template slot="first"><option :value="null" disabled>-- select type contract --</option></template>
                </b-form-select>
            </b-form-group> 
            <b-form-group :label-cols="4" id="L3" label="Start Date" label-for="Tdg3" horizontal>
              <b-form-input id="Tdg3" type="date" v-model="model.start_date"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L4" label="Of Months" label-for="Tdg4" horizontal>
              <b-form-input id="Tdg4" type="text" v-model="model.of_months" v-mask="'##'" placeholder="Only numbers(max 2 digits)" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L5" label="Volume" label-for="Tdg5" horizontal>
              <b-form-input id="Tdg5" type="text" v-model="model.volume" v-mask="'#########'" placeholder="Only numbers(max 9 digits)" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L6" label="Diff" label-for="Tdg6" horizontal>
              <b-form-input id="Tdg6" type="text" v-model="model.diff" placeholder="0.00" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'diff')" @blur.native="inputBlur('diff')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L7" horizontal label="Index Contract" label-for="Tdg7">
                <b-form-select :disabled="index_contract.length==0" value-field="id" text-field="name" id="Tdg7" v-model="model.index_contract_id" :options="index_contract">
                 <template slot="first"><option :value="null" disabled>-- select index contract --</option></template>
                </b-form-select> 
            </b-form-group> 
            <b-form-group :label-cols="4" id="L8" label="App" label-for="Tdg8" horizontal>
              <b-form-input id="Tdg8" type="text" v-model="model.app" placeholder="0.00" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'app')" @blur.native="inputBlur('app')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L9" label="trader" label-for="Tdg9" horizontal>
              <b-form-input id="Tdg9" type="text" v-model="model.trader"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L10" label="Priority" label-for="Tdg10" horizontal>
              <b-form-input id="Tdg10" type="text" v-model="model.priority" v-mask="'##'" placeholder="Only numbers(max 2 digits)" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L11" label="Placeholder 1" label-for="Tdg11" horizontal>
              <b-form-input id="Tdg11" type="text" v-model="model.placeholder_1" placeholder="Optional"></b-form-input>
            </b-form-group>  
            <b-form-group :label-cols="4" id="L12" label="Placeholder 2" label-for="Tdg12" horizontal>
              <b-form-input id="Tdg12" type="text" v-model="model.placeholder_2" placeholder="Optional"></b-form-input>
            </b-form-group> 
            <b-form-group :label-cols="4" id="L13" label="Invoice Customer" label-for="Tdg13" horizontal>
              <b-form-select :disabled="invoice_customer.length==0" value-field="id" text-field="name" id="Tdg13" v-model="model.invoice_customer_id" :options="invoice_customer">
                                <template slot="first"><option :value="null" disabled>-- select customer --</option></template>
                </b-form-select> 
            </b-form-group>

            <b-form-group :label-cols="4" id="L15" label="Nomination(m3)" label-for="Tdg15" horizontal>
              <b-form-input id="Tdg15" type="text" v-model="model.nomination_m3" placeholder="0.00" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'nomination_m3')" @blur.native="inputBlur('nomination_m3')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L16" label="Nomination(bbl)" label-for="Tdg16" horizontal>
              <b-form-input id="Tdg16" type="text" v-model="model.nomination_bbl" placeholder="0.00" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'nomination_bbl')" @blur.native="inputBlur('nomination_bbl')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L17" label="Post Appomt. Nomination" label-for="Tdg17" horizontal>
              <b-form-input id="Tdg17" type="text" v-model="model.post_appomt_nom" placeholder="0.00" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'post_appomt_nom')" @blur.native="inputBlur('post_appomt_nom')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L18" label="Price Description" label-for="Tdg18" horizontal>
              <b-form-input id="Tdg18" type="text" v-model="model.price_description" autocomplete="off"  ></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L14" label="Attach Pdfs" label-for="file" horizontal>
                <b-table striped show-empty empty-text="No pdf file have been added"
                    :fields = "[{key: 'delete', label: ' '}, {key: 'name', label: ' '}]" 
                    :items="model.pdfs" stacked="sm" outlined small>
                    <template slot="delete" slot-scope="item">
                      <b-btn v-b-tooltip.hover title="Delete" v-on:click="removefile(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
                    </template>
                    <template slot="name" slot-scope="item">
                      <input type="file" class="form-control-file" id="files" ref="file" accept="application/pdf" v-on:change="handleFileUpload(item.index)" />
                    </template>
                </b-table>
                <b-row>
                  <b-col sm="12">
                    <b-btn  v-on:click="anotherfile()" size="sm" variant="primary" class="pull-right">Add another Pdf</b-btn>
                  </b-col>
                </b-row>				      
			      </b-form-group>            
        </b-col>  
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="newIC=false" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveIC" class="float-right">Save</b-btn>
      </div>
    </b-modal>
    <!-- End New Tdg Modal-->
    </div>
</template>

<script>
  import Vue from 'vue'
  import invoice_service from './invoices_service'

  const items = []
  export default {
    name: 'Contract',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        trash               : false,
        dpdt                : 'Active',
        model               : {
                        contract_name       : '',
                        type_contract_id    : null,
                        start_date          : '',
                        of_months           : '',
                        volume              : '',
                        diff                : '',
                        index_contract_id   : null,
                        app                 : '',
                        trader              : '',
                        priority            : '',
                        placeholder_1       : '',
                        placeholder_2       : '',
                        invoice_customer_id : null,
                        pdfs                 : [{
                          'name': '',
                          'file_64':'',
                        }],
                        nomination_m3       : '',
                        nomination_bbl      : '',
                        post_appomt_nom     : '',
                        price_description   : '',
                            },
        newIC               : false,
        items               : items,
        fields              : [
                        {
                            key: 'id',
                            label: 'ID',
                            sortable: true
                        },
                        {
                            key: 'contract_name',
                            label: 'Contract Name',
                            sortable: true
                        },
                        {
                            key: 'type_contract_name',
                            label: 'Type Contract',
                            sortable: false
                        },
                        {
                            key: 'start_date',
                            label: 'Start Date',
                            sortable: false
                        },
                        {
                            key: 'of_months',
                            label: 'Of month',
                            sortable: false
                        },
                        {
                            key: 'volume',
                            label: 'Volume',
                            sortable: false
                        },
                        {
                            key: 'diff',
                            label: 'Diff',
                            sortable: false
                        },
                        {
                            key: 'index_contract_name',
                            label: 'Index Contract',
                            sortable: false
                        },
                        {
                            key: 'app',
                            label: 'App',
                            sortable: false
                        },
                        {
                            key: 'trader',
                            label: 'Trader',
                            sortable: false
                        },
                        {
                            key: 'priority',
                            label: 'Priority',
                            sortable: false
                        },
                        {
                            key: 'placeholder_1',
                            label: 'Placeholder 1',
                            sortable: false
                        },
                        {
                            key: 'placeholder_2',
                            label: 'Placeholder 2',
                            sortable: false
                        },
                        {
                            key: 'invoice_customer_name',
                            label: 'Customer',
                            sortable: false
                        },
                        {
                            key: 'nomination_m3',
                            label: 'Nomination(m3)',
                            sortable: false
                        },
                        {
                            key: 'nomination_bbl',
                            label: 'Nomination(bbl)',
                            sortable: false
                        },
                        {
                            key: 'post_appomt_nom',
                            label: 'Post Appomt. Nomination',
                            sortable: false
                        },
                        {
                            key: 'price_description',
                            label: 'Price Description',
                            sortable: false
                        },
                            ],
        currentPage         : 1,
        perPage             : 25,
        totalRows           : items.length,
        pageOptions         : [25, 50, 100],
        sortBy              : 'id',
        sortDesc            : false,
        filter              : null,
        loadingData         : true,
        savebtn             :true,
        type_contract		    : [],
        index_contract      : [],
        invoice_customer    : [],
        url                 : '',
        file                : '',
        infile : {
            'name': '',
            'file_64':'',
        },
        otherfile : {
            'name': '',
            'file_64':'',
        }
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })
      }
    },
    methods: {
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        newICModal() {
            this.model = {
                        contract_name       : '',
                        type_contract_id    : null,
                        start_date          : '',
                        of_months           : '',
                        volume              : '',
                        diff                : '',
                        index_contract_id   : null,
                        app                 : '',
                        trader              : '',
                        priority            : '',
                        placeholder_1       : '',
                        placeholder_2       : '',
                        invoice_customer_id : null,
                        pdfs                 : [{
                          'name': '',
                          'file_64':'',
                        }],
                        nomination_m3       : '',
                        nomination_bbl      : '',
                        post_appomt_nom     : '',
                        price_description   : '',
                        }
            this.infile = {
              'name': '',
              'file_64':'',
            }
            this.savebtn=false
            this.newIC = true
            this.$refs.file.value = null
        },
        trashIC() {
                    this.trash = !this.trash
                    this.dpdt = this.trash ? "Trash" : "Active"
                    this.getAll()
                    this.loadingData = true
                },
        rowClicked(row) {
                    if(!this.trash) {
                        this.$router.push('/invoice_contract/' + row.id + '/')
                    } else {
                        this.restoreIC(row.id)
                    }
        },
        okToSave() {
                 if (this.model.contract_name === undefined || this.model.contract_name.trim().length == 0) {
                    this.$swal('Alert!', 'Contract Name can not be empty', 'warning')
                    return false
                }
                if (this.model.start_date === undefined || this.model.start_date.trim().length == 0) {
                    this.$swal('Alert!', 'Start Date can not be empty', 'warning')
                    return false
                }
                if (this.model.of_months === undefined || this.model.of_months.trim().length == 0) {
                    this.$swal('Alert!', 'Of Months can not be empty', 'warning')
                    return false
                }
                if (this.model.volume === undefined || this.model.volume.trim().length == 0) {
                    this.$swal('Alert!', 'Volume can not be empty', 'warning')
                    return false
                }
                if (this.model.diff === undefined || this.model.diff.trim().length == 0) {
                    this.$swal('Alert!', 'Diff can not be empty', 'warning')
                    return false
                }
                if (this.model.trader === undefined || this.model.trader.trim().length == 0) {
                    this.$swal('Alert!', 'Trader can not be empty', 'warning')
                    return false
                }
                if (this.model.priority === undefined || this.model.priority.trim().length == 0) {
                    this.$swal('Alert!', 'Priority can not be empty', 'warning')
                    return false
                }
                if (this.model.type_contract_id === undefined || this.model.type_contract_id == null) {
                    this.$swal('Alert!', 'Select Type Contract', 'warning')
                    return false
                }
                if (this.model.index_contract_id === undefined || this.model.index_contract_id == null) {
                    this.$swal('Alert!', 'Select Index Contract', 'warning')
                    return false
                }
                if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id == null) {
                    this.$swal('Alert!', 'Select Customer', 'warning')
                    return false
                } 


				return true

	      }, 
        saveIC () {
            if (!this.okToSave()) {
                    return
            }
            console.log(this.model)
            invoice_service.save_IC1(this.model)
            .then(data => {
                this.$swal(data.status, data.message, data.status)
                .then((result) => {
                    if (data.status == 'success') {
                    this.newIC = false
                    this.getAll()
                    }
                })
            })
            .catch(error => {
                this.$swal('Error', 'Server not response. ' + error, 'error')
            })
            this.savebtn=false
        }, 
        getAll() {
            this.loadingData = true
            invoice_service.getAll_cc()
            .then(data => {
                if (data.status == 'success') {
                    this.items              = data.invoice_contract.filter(o => o.status_id == (this.trash ? 2 : 1))
                    this.type_contract      = data.type_contract
                    this.index_contract     = data.index_contract
                    this.invoice_customer   = data.invoice_customer
                    console.log(this.items)
                }else {
                    this.$swal(data.status, data.message, data.status)
                    this.type_contract    = []
                    this.index_contract   = []
                    this.invoice_customer = []
                    this.loadingData = false
                return
                }
                this.loadingData = false
            })
            .catch(error => {
                Vue.swal('Error', 'Server not response. ' + error, 'error')
                this.loadingData = false
            })
        },
        restoreIC(id) {
                  this.$swal({
                          title: 'Please, confirm',
                          text: "Are you sure to restore this Contract ?",
                          type: 'question',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Yes',
                          reverseButtons: true
                      }).then((result) => {
                          if (result.value) {
                              invoice_service.restore_icontract(id)
                                  .then(data => {
                                      this.$swal(data.status, data.message, data.status)
                                      if (data.status == 'success') {
                                          this.filter = ''
                                          this.trash = false
                                          this.getAll()
                                          this.loadingData = true
                                      }
                                  })
                                  .catch(error => {
                                      this.$swal('Error', 'Server not response. ' + error, 'error')
                                  })
                          }
                      })
        },
        inputBlur(variableName) {
          let variableValue = this.model[variableName]
          if (variableValue.length == 0) {
            if (variableName!=="exchange_rate") {
                this.model[variableName] = "0.00"
            } else {
                this.model[variableName] = "0.0000"
            }
            
          } else {
            let tempValue = variableValue.split(".")
            if (tempValue.length == 1) {
                if (variableName!=="exchange_rate") {
                    this.model[variableName] = String(variableValue) + ".00"
                } else {
                    this.model[variableName] = String(variableValue) + ".0000"
                }           
            } else if (tempValue.length == 2) {
                if (variableName!=="exchange_rate") {
                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
                } else {
                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "0000").slice(0, 4)
                }
                
            }
          }
        },
        myOnlyNumber(evt, variableName) {
          let dotPosition = this.model[variableName].indexOf(".")
          let hasDot = dotPosition > -1
          let length = this.model[variableName].length
          if (variableName!=="exchange_rate") {
              this.isNumber(evt, hasDot, dotPosition, length, 2)
          } else {
              this.isNumber(evt, hasDot, dotPosition, length, 4)
          }
        },
        isNumber: function(evt, hasDot, dotPosition, length, n_digit) {

          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
            let selectionStart = evt.target.selectionStart;
            let selectionEnd = evt.target.selectionEnd;
            if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length -  n_digit> dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
              evt.preventDefault();
            } else {
              return true
            }
          } else {
            evt.preventDefault();
          }
        },
        handleFileUpload(index) {

          if (this.$refs.file.files.length>0) {

              this.file = this.$refs.file.files[0]
              this.infile.name = this.file.name//this.$refs.files.files[i].name
              
              let url = window.URL.createObjectURL(this.file)
              this.url = url
              setTimeout(() => window.URL.revokeObjectURL(url), 100)
              let reader = new FileReader()
              reader.readAsDataURL(this.file)             
              reader.onload = function() {
                localStorage.setItem('file_64', reader.result)      
                return
              }        
              this.infile.file_64 = localStorage.getItem('file_64')

              this.model.pdfs[index].name = this.infile.name
              this.model.pdfs[index].file_64 = this.infile.file_64
              console.log('-model-->',this.model.pdfs)  
          }
        },
        removefile(otherfile) {
				  this.model.pdfs.splice(otherfile,1)
				},
        anotherfile() {

          if (this.model.pdfs.length===0) {
						  this.model.pdfs.push(this.otherfile)
              this.infile = {
                'name': '',
                'file_64':'',
              }
          } else {
            if (this.infile.name !== '') {
                this.model.pdfs.push(this.otherfile)
                this.infile = {
                  'name': '',
                  'file_64':'',
                }
            } else {
                this.$swal('warning', 'File no selected', 'warning')
            }
          }

        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/invoices/invoice_contracts.vue